const state = {
  transactionsPayoutId: null,
}

const mutations = {
  setTransactionPayoutId (state, payoutId) {
    state.transactionsPayoutId = payoutId
  },
}


export const transactions = {
  namespaced: true,
  state,
  mutations
}